module.exports = __webpack_public_path__ + "static/media/btn_secondaryschool_07_TheNetizenPledge.a7bf194c.png";